"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Map_exports = {};
__export(Map_exports, {
  default: () => Map_default
});
module.exports = __toCommonJS(Map_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.29688 3.72656C7.36198 3.67448 7.42708 3.64844 7.49219 3.64844C7.57031 3.64844 7.64193 3.66146 7.70703 3.6875L13.293 6.8125C13.3581 6.83854 13.4232 6.85156 13.4883 6.85156C13.5664 6.85156 13.638 6.82552 13.7031 6.77344L18.1953 4.01953C18.3255 3.92839 18.4622 3.92188 18.6055 4C18.7617 4.07812 18.8398 4.20182 18.8398 4.37109V13.1406C18.8398 13.2839 18.8073 13.4141 18.7422 13.5312C18.6771 13.6484 18.5859 13.7461 18.4688 13.8242L13.7031 16.7734C13.638 16.8255 13.5664 16.8516 13.4883 16.8516C13.4232 16.8516 13.3581 16.8385 13.293 16.8125L7.70703 13.6875C7.64193 13.6615 7.57031 13.6484 7.49219 13.6484C7.42708 13.6484 7.36198 13.6745 7.29688 13.7266L2.82422 16.4805C2.68099 16.5716 2.53125 16.5781 2.375 16.5C2.23177 16.4219 2.16016 16.2982 2.16016 16.1289V7.35938C2.16016 7.21615 2.19271 7.08594 2.25781 6.96875C2.32292 6.85156 2.41406 6.75391 2.53125 6.67578L7.29688 3.72656ZM3.17578 15.0547L6.75 12.8867C6.78906 12.8607 6.82812 12.8346 6.86719 12.8086C6.90625 12.7826 6.95182 12.763 7.00391 12.75V5.11328L3.17578 7.45703V15.0547ZM8 12.7305C8.02604 12.7435 8.05208 12.7565 8.07812 12.7695C8.10417 12.7695 8.13021 12.776 8.15625 12.7891L13 15.543V7.76953C12.974 7.75651 12.9479 7.75 12.9219 7.75C12.8958 7.73698 12.8698 7.72396 12.8438 7.71094L8 4.95703V12.7305ZM13.9961 7.75V15.3867L17.8242 13.043V5.44531L14.25 7.61328C14.2109 7.63932 14.1719 7.66536 14.1328 7.69141C14.0938 7.71745 14.0482 7.73698 13.9961 7.75Z",
      fill: "currentColor"
    }
  )
);
const SvgMap = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Map_default = SvgMap;
